import React from 'react';

import { formatNumberK } from 'util/formatters/numberFormatter';
import { getMessage } from 'util/locale';

const AveragePlantingPopulationRateRow = ({
  originalAvgRate,
  activeAvgRate,
  yourPlanAvgRate
}: {
  originalAvgRate: number;
  activeAvgRate: number;
  yourPlanAvgRate: number;
}) => (
  <tr>
    <th role='rowheader'>{getMessage('avg-planting-population')}</th>
    <td>{formatNumberK(yourPlanAvgRate)}</td>
    <td>{formatNumberK(originalAvgRate)}</td>
    <td>{formatNumberK(activeAvgRate)}</td>
  </tr>
);

export default AveragePlantingPopulationRateRow;
